export class TeklifOlusturRequest {

  talepId: number;
  cariIdList: number[] = [];
  mailGonderCariIdList: number[] = [];
  satinAlmaNotu = '';
  teslimYeriId: number = null;
  gorselGosterCariIdList: number[] = [];


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
